import { render } from "./RiWidgetCost.vue?vue&type=template&id=65c5a984"
import script from "./RiWidgetCost.vue?vue&type=script&lang=js"
export * from "./RiWidgetCost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiWidgetCost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65c5a984"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65c5a984', __exports__)) {
    api.reload('65c5a984', __exports__)
  }
  
  module.hot.accept("./RiWidgetCost.vue?vue&type=template&id=65c5a984", () => {
    api.rerender('65c5a984', render)
  })

}


export default __exports__